import { createFormElement } from '@vfde-brix/ws10/form-element';
import { IValidation } from '@vfde-brix/ws10/validation';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';

/**
 * Create Brix Form Element component.
 *
 * @param id - Wrapper ID of the element.
 * @param onChange - OnInput and OnChange event handler.
 * @param validation - FormField validation.
 * @returns Form Element component or null if
 * the element with the given ID is not found.
 */
export const mountFormElement = (id: HtmlId, onChange: (value: string) => void, validation?: IValidation[]) =>
    mountComponent(id, createFormElement, {
        onInput: (event, value) => onChange(value),
        onChange: (event, value) => onChange(value),
        validation,
    });
